import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right-parenthesis",
  "use": "right-parenthesis-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right-parenthesis\"><path d=\"M30,394 L33.9937891,394 C42.2814906,394 49,387.286093 49,379 C49,370.715729 42.2833128,364 33.9937891,364 L30.0001528,364 C35.3543361,366.862855 38.9958594,372.506227 38.9958594,379 C38.9958594,385.494894 35.3536929,391.137491 29.9999991,394.000001 Z\" transform=\"translate(-30 -364)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/right-parenthesis.svg
// module id = 733
// module chunks = 0